import {
  ArrayInput,
  Button,
  maxLength,
  RecordContextProvider,
  required,
  SimpleFormIterator,
  TextInput,
  useNotify,
  useRefresh,
} from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import AddIcon from "@mui/icons-material/Add";
import { Grid } from "@mui/material";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";

const AddModulesDialog = ({ curriculumId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    const payload = {
      modules: (data.modules || []).map(m => ({
        nameBg: m.nameBg,
        nameEn: m.nameEn,
      })),
    };

    await dataProvider.customRequest(specialistRequests.addCurriculumModules(curriculumId), payload, "POST");
    notify("Успешно добавени модули", { type: "success" });
    refresh();
  };

  return (
    <RecordContextProvider value={{}}>
      <FormModal
        titleContent="Добави модули"
        dialogSize="md"
        onConfirm={handleSubmit}
        defaultValues={{ modules: [{}] }}
        triggerButton={
          <Button
            label="Добави модули"
            variant="contained"
            size="medium"
            startIcon={<AddIcon />}
            sx={{ mt: 2 }}
          />
        }
      >
        <ArrayInput
          source="modules"
          label="Модули"
        >
          <SimpleFormIterator>
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                xs={12}
                md={6}
              >
                <TextInput
                  source="nameBg"
                  label="Наименование (БГ)"
                  validate={[required(), maxLength(200)]}
                  fullWidth
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
              >
                <TextInput
                  source="nameEn"
                  label="Наименование (EN)"
                  validate={[required(), maxLength(200)]}
                  fullWidth
                />
              </Grid>
            </Grid>
          </SimpleFormIterator>
        </ArrayInput>
      </FormModal>
    </RecordContextProvider>
  );
};

export default AddModulesDialog;
